/* eslint-disable import/no-relative-packages */

/**
 * This is a map of the locales and their corresponding json files. We list them
 * here STATICALLY so that our static analysis tooling and bundlers know exactly
 * where to find them.
 */
export const localesJsonMap: Record<
  string,
  Record<string, () => Promise<any>>
> = {
  en: {
    common: () => import("../../../locales/en/common.json"),
    content: () => import("../../../locales/en/content.json"),
    customTerms: () => import("../../../locales/en/customTerms.json"),
  },
  de: {
    common: () => import("../../../locales/de/common.json"),
    content: () => import("../../../locales/de/content.json"),
    customTerms: () => import("../../../locales/de/customTerms.json"),
  },
  es: {
    common: () => import("../../../locales/es/common.json"),
    content: () => import("../../../locales/es/content.json"),
    customTerms: () => import("../../../locales/es/customTerms.json"),
  },
  "fr-CA": {
    common: () => import("../../../locales/fr-CA/common.json"),
    content: () => import("../../../locales/fr-CA/content.json"),
    customTerms: () => import("../../../locales/fr-CA/customTerms.json"),
  },
  "fr-FR": {
    common: () => import("../../../locales/fr-FR/common.json"),
    content: () => import("../../../locales/fr-FR/content.json"),
    customTerms: () => import("../../../locales/fr-FR/customTerms.json"),
  },
  it: {
    common: () => import("../../../locales/it/common.json"),
    content: () => import("../../../locales/it/content.json"),
    customTerms: () => import("../../../locales/it/customTerms.json"),
  },
  ja: {
    common: () => import("../../../locales/ja/common.json"),
    content: () => import("../../../locales/ja/content.json"),
    customTerms: () => import("../../../locales/ja/customTerms.json"),
  },
  ko: {
    common: () => import("../../../locales/ko/common.json"),
    content: () => import("../../../locales/ko/content.json"),
    customTerms: () => import("../../../locales/ko/customTerms.json"),
  },
  "pt-BR": {
    common: () => import("../../../locales/pt-BR/common.json"),
    content: () => import("../../../locales/pt-BR/content.json"),
    customTerms: () => import("../../../locales/pt-BR/customTerms.json"),
  },
  "zh-CN": {
    common: () => import("../../../locales/zh-CN/common.json"),
    content: () => import("../../../locales/zh-CN/content.json"),
    customTerms: () => import("../../../locales/zh-CN/customTerms.json"),
  },
  "zh-TW": {
    common: () => import("../../../locales/zh-TW/common.json"),
    content: () => import("../../../locales/zh-TW/content.json"),
    customTerms: () => import("../../../locales/zh-TW/customTerms.json"),
  },
} as const;

export type Locale = keyof typeof localesJsonMap;
export const locales: Locale[] = Object.keys(localesJsonMap);

export const namespaces = ["common", "content", "customTerms"] as const;
export type Namespace = (typeof namespaces)[number];
